import { Pipe, PipeTransform } from '@angular/core';
import { ErrorMessage, FormFieldConfig } from '@mri/types';

@Pipe({
  name: 'formDataSetRenderError',
})
export class FormDataSetRenderErrorPipe implements PipeTransform {

  transform(errors: ErrorMessage[], field: FormFieldConfig): ErrorMessage[] {
    return errors?.filter(e => e.fieldKey === field.key) || [];
  }

}
